<template>
  <div id="forecast-windy-popup">
    <p>緯度:{{ lngLat.lat.toFixed(6) }}, 経度:{{ lngLat.lng.toFixed(6) }}</p>
    <div v-if="forecastTable">
      <br />
      <p>直近24時間の予報（3時間毎）</p>
      <table class="forecast-windy-popup-table">
        <tr>
          <th></th>
          <td colspan="3" class="forecast-windy-popup-subtitle">風 (速度/最大瞬間/方向)</td>
          <td colspan="3" class="forecast-windy-popup-subtitle">波 (高さ/間隔/方向)</td>
          <td colspan="3" class="forecast-windy-popup-subtitle">うねり (高さ/間隔/方向)</td>
        </tr>
        <tr v-for="( forecastRow, rowIndex ) in forecastTable" :key="rowIndex" >
          <td v-for="( forecastCol, colIndex )  in forecastRow" :key="colIndex">
            <div v-if="forecastCol.match(/deg$/g) !== null"  :style="createAllowStyle(forecastCol)">
              ↑
            </div>
            <div v-else>
              {{ forecastCol }}
            </div>
          </td>
        </tr>
      </table>
      <div class="flex justify-center">
        <vs-button
            color="primary"
            @click="$emit('emit-show-forecast-detail')"
            class="flex items-center h-1 forecast-windy-detail-button"
        >詳細を表示</vs-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { DateUtil } from "@/utils";
import { createNamespacedHelpers } from "vuex";
const { mapState, mapActions } = createNamespacedHelpers(
  "forecastWindy"
);

export default {
  props: {
    lngLat: Object
  },
  data: function () {
    return {
        forecastTable: null
    }
  },
  computed: {
    ...mapState({
      forecastData: state => state.forecastData,
    })
  },
  methods: {
    ...mapActions(["fetchForecast"]),

    /**
     * WindyAPIの気象海象予報を表示用オブジェクトとして加工.
     */
    convertForecastDataForPopup(){
      const forecastData = this.forecastData;

      function toDispValue(dataObject, keyName, arrayIndex, decimalDigit) {
        if ( ! dataObject[keyName][arrayIndex] ) { return ''; }
        let dispValue = isNaN(decimalDigit)
                          ? dataObject[keyName][arrayIndex]
                          : dataObject[keyName][arrayIndex].toFixed(decimalDigit);
        dispValue += ' ' + dataObject.units[keyName];
        return dispValue;
      }

      const past3HourMilliSeconds = ( DateUtil.currentEpochSeconds() - 3 * 60 * 60 ) * 1000;
      let forecastTable = [];
      let forecastColArray = [];
      for (let i=0; i < forecastData.ts.length; i++ ) {
        if ( past3HourMilliSeconds < forecastData.ts[i] ){
          forecastColArray = [];
          forecastColArray.push(DateUtil.toMomentObj(forecastData.ts[i]).format("HH:mm"));

          // 風 (速度/最大瞬間/方向)
          forecastColArray.push(toDispValue(forecastData, 'wind_speed-surface', i,  2));
          forecastColArray.push(toDispValue(forecastData, 'gust-surface', i,  2));
          forecastColArray.push(toDispValue(forecastData, 'wind_direction-surface', i,  2));

          // 波 (高さ/間隔/方向)
          forecastColArray.push(toDispValue(forecastData, 'waves_height-surface', i,  2));
          forecastColArray.push(toDispValue(forecastData, 'waves_period-surface', i,  2));
          forecastColArray.push(toDispValue(forecastData, 'waves_direction-surface', i,  2));

          // うねり (高さ/間隔/方向)
          forecastColArray.push(toDispValue(forecastData, 'swell1_height-surface', i,  2));
          forecastColArray.push(toDispValue(forecastData, 'swell1_period-surface', i,  2));
          forecastColArray.push(toDispValue(forecastData, 'swell1_direction-surface', i,  2));

          forecastTable.push(forecastColArray) ;
          if (forecastTable.length > ( 24 / 3 )){ break; }
        }
      }

      this.forecastTable = forecastTable;
    },
    
    /**
     * 風向などを表現するためにdivタグを指定角度で回転させる.
     */
    createAllowStyle(degreeValue) {
      degreeValue = degreeValue.replace(/ /g, '');
      return { 
        'transform': 'rotate(' + degreeValue + ')',
        '-webkit-transform': 'rotate(' + degreeValue + ')',
        'width':'0px',
        'height':'0px',
        'display': 'flex',
        'justify-content': 'center',
        'align-items': 'center',
        'padding':'0 1rem',
      }
    },
  },
  async mounted() {
    await this.fetchForecast(this.lngLat);
    this.convertForecastDataForPopup();
  },
}
</script>

<style lang="scss" scoped>

.forecast-windy-popup-table {

  .forecast-windy-popup-subtitle {
    text-align: left;
  }
  td {
    white-space: nowrap;
    border: solid 1px #000000;
    border-collapse: separate;
    text-align: right;
    padding: 0 0.5rem;
  }
}

.forecast-windy-detail-button {
  margin-top:0.5rem;
}
</style>